module.exports = __webpack_public_path__ + "img/1f614.747ed85.svg";